import "core-js/modules/es.array.map.js";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { x } from '@xstyled/styled-components';
import { ExpandLessIcon, ExpandMoreIcon, HDivider, HSpacer, ProductSection, SectionTitle } from '@aftersale-next/ui';
import { useTranslation } from 'react-i18next';
import { useProducts } from '../../hooks/use-products';
import { ProductItem } from './product-item';
export function PackageProducts(_ref) {
  var isExpanded = _ref.isExpanded,
      onClick = _ref.onClick;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useProducts = useProducts(),
      products = _useProducts.products;

  if (!products.length) return null;
  return /*#__PURE__*/_jsxs(ProductSection, {
    onClick: onClick,
    "data-testid": "package-products",
    children: [/*#__PURE__*/_jsxs(x.div, {
      display: "flex",
      "data-testid": "package-products-section-title",
      children: [/*#__PURE__*/_jsx(SectionTitle, {
        children: t('PACKAGE_PRODUCTS')
      }), /*#__PURE__*/_jsx(x.div, {
        ml: "auto",
        children: isExpanded ? /*#__PURE__*/_jsx(ExpandMoreIcon, {}) : /*#__PURE__*/_jsx(ExpandLessIcon, {})
      })]
    }), isExpanded && products.map(function (product, index, array) {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(HSpacer, {
          space: "24px"
        }), /*#__PURE__*/_jsx(ProductItem, {
          product: product
        }, product.sku), index < array.length - 1 && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(HSpacer, {
            space: "16px"
          }), /*#__PURE__*/_jsx(HDivider, {}), /*#__PURE__*/_jsx(HSpacer, {
            space: "16px"
          })]
        })]
      });
    })]
  });
}